import React, {useMemo, useState} from "react";
import {makeStyles} from "@mui/styles";
import {Button, CircularProgress, Dialog, DialogActions, DialogContent, Divider, Typography} from "@mui/material";
import {ClosableDialogTitle, Info, TabBar, TabPanel} from "@atttomyx/react-components";
import {MessageForm} from "../forms";
import {helpService} from "../../services";
import {arrays, strings} from "@atttomyx/shared-utils";
import "./helpDialog.css";

const useStyles = makeStyles(theme => ({
    paper: {
        maxWidth: "600px",
        minWidth: "300px",
    },
}));

const toData = (question) => {
    return {
        message: question,
        valid: false,
    }
};

const HelpDialog = (props) => {
    const { snackbar, onCancel } = props;
    const [ data, setData ] = useState(toData(null));
    const [ spinner, setSpinner ] = useState(false);
    const [ question, setQuestion ] = useState(null);
    const [ answer, setAnswer ] = useState(null);
    const [ tab, setTab ] = useState(0);

    const message1 = useMemo(() => {
        return arrays.splitOnNewline(question);
    }, [question]);

    const message2 = useMemo(() => {
        return arrays.splitOnNewline(answer);
    }, [answer]);

    const submitForm = () => {
        const asking = data.message;

        const success = (answer) => {
            setSpinner(false);

            if (tab === 0) {
                setAnswer(answer);

            } else {
                snackbar.setSuccess("Ed and Scott have been sent your question");
            }
        };

        const failure = (err) => {
            snackbar.setError(err);
            setData(toData(asking));
            setSpinner(false);
        };

        setSpinner(true);
        setData(toData(null));

        if (tab === 0) {
            setQuestion(asking);
            setAnswer(null);

            helpService.askAi(asking, success, failure);

        } else {
            helpService.askHuman(asking, success, failure);
        }
    }

    return <Dialog
        open={true}
        aria-labelledby="help-dialog"
        classes={useStyles()}
    >
        <ClosableDialogTitle onClose={onCancel}>
            Help
        </ClosableDialogTitle>
        <DialogContent className="help-dialog">
            <TabBar
                tabs={["Ask AI", "Ask Human"]}
                value={tab}
                onChange={setTab}
            />
            <TabPanel value={tab} index={0}>
                {message1.length > 0 ?
                    <>
                        <div className="message">
                            {message1.map(line => strings.isBlank(line) ? null :
                                <Typography key={line} variant="caption" component="p">
                                    {line}
                                </Typography>)}
                        </div>
                        <Divider/>
                    </> : null}
                {message2.length > 0 ?
                    <>
                        <div className="message">
                            {message2.map(line => strings.isBlank(line) ? null :
                                <Typography key={line} variant="caption" component="p">
                                    {line}
                                </Typography>)}
                        </div>
                        <Divider/>
                    </> : null}
            </TabPanel>
            <TabPanel value={tab} index={1}/>
            {spinner ?
                <CircularProgress size="40px"/> :
                <MessageForm
                    label="Question?"
                    data={data}
                    onChange={setData}
                    showOrder={true}
                />}
            {tab === 1 && !spinner ?
                <Info>Ed or Scott will get back to you within 48 hours</Info> : null}
        </DialogContent>
        {!spinner ? <DialogActions>
            <Button color="primary"
                    disabled={!data.valid}
                    onClick={submitForm}>
                {tab === 0 ? "Ask AI" : "Ask Human"}
            </Button>
        </DialogActions> : null}
    </Dialog>
}

export default HelpDialog;
